module.exports = __webpack_public_path__ + "static/media/cardo_mariano.c1c50850.jpg";